import { Container } from "react-bootstrap";
import "./css/style.css";
import { useState } from "react";

export default function Plus() {
    const [activeButtons, setActiveButtons] = useState({});

    const handleButtonClick = (buttonNumber) => {
        setActiveButtons((prev) => ({
            ...prev,
            [buttonNumber]: !prev[buttonNumber], // Переключаем видимость для нажатой кнопки
        }));
    };

    return (
        <>
            <section id="plus" className="plus">
                <Container className="plus_container sect">
                    <div className="plus_screens">
                        <div className="plus_screens_picture_one">
                            <img className="fon_picture" src="/img/profitably/01.png" alt="картинка" />
                            {/* Кнопка 1 для первого изображения */}
                            <div className="button-wrapper button-wrapper1">
                                <button className="plus_button plus_button1" onClick={() => handleButtonClick(1)}>
                                    <img src="/img/icon/pl.png" className={activeButtons[1] ? "rotated" : ""} alt="icon" />
                                </button>
                                <div className={`description-box ${activeButtons[1] ? "visible" : "hidden"}`}>
                                    <h3 className="plus_description_title">надежность</h3>
                                    <p className="plus_description_text">Надежная защита и низкое потребление энергии</p>
                                </div>
                            </div>

                            {/* Кнопка 2 для первого изображения */}
                            <div className="button-wrapper button-wrapper2 button-wrapper_rotate">
                                <button className="plus_button plus_button2" onClick={() => handleButtonClick(2)}>
                                    <img src="/img/icon/pl.png" className={activeButtons[2] ? "rotated" : ""} alt="icon" />
                                </button>
                                <div className={`description-box ${activeButtons[2] ? "visible" : "hidden"}`}>
                                    <h3 className="plus_description_title">габариты</h3>
                                    <p className="plus_description_text">Возможен любой размер led экрана без потери яркости и качества картинки</p>
                                </div>
                            </div>
                        </div>
                        <div className="plus_screens_picture_two">
                            <img className="fon_picture" src="/img/profitably/02.png" alt="картинка" />
                            {/* Кнопка 3 для второго изображения */}
                            <div className="button-wrapper button-wrapper3">
                                <button className="plus_button plus_button3" onClick={() => handleButtonClick(3)}>
                                    <img src="/img/icon/pl.png" className={activeButtons[3] ? "rotated" : ""} alt="icon" />
                                </button>
                                <div className={`description-box ${activeButtons[3] ? "visible" : "hidden"}`}>
                                    <h3 className="plus_description_title">ВЫГОДНО</h3>
                                    
                                    <p className="plus_description_text">Быстрый и профессиональный монтаж и демонтаж</p>
                                </div>
                            </div>

                            {/* Кнопка 4 для второго изображения */}
                            <div className="button-wrapper button-wrapper4 button-wrapper_rotate">
                                <button className="plus_button plus_button4" onClick={() => handleButtonClick(4)}>
                                    <img src="/img/icon/pl.png" className={activeButtons[4] ? "rotated" : ""} alt="icon" />
                                </button>
                                <div className={`description-box ${activeButtons[4] ? "visible" : "hidden"}`}>
                                    <h3 className="plus_description_title">удобно</h3>
                                    <p className="plus_description_text">Вам не придется думать о монтаже, доставке и настройке экрана</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </>
    );
}
